module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-10-12c2daccbe093b8f15b227bd95b16483.jpg";